import {useContext} from 'react';
import EventContext from '/context/EventContext.js';

export default function DescriptionView({id, classIdentifier}) {
    const {event} = useContext(EventContext);

    return (
        <section className={classIdentifier} id={id}>
          <div className='mt-8 pb-8 md:pb-16'>
            <h1 className='text-lg xl:text-xl text-gray-dark font-cooper'>Inhalt</h1>
            <div className="text-gray-dark text-sm xl:text-base mt-[21px]"
                 dangerouslySetInnerHTML={{__html: (event || {}).organizer_description}}
            >

            </div>
            <div className="flex flex-wrap mt-[21px]">
              {((event || {}).images || []).slice(1, 3).map(image => (
                  <div key={image.url} className="mr-[18px] mb-[18px]">
                    <img src={image.url} style={{height: 204, width: 'auto'}}/>
                  </div>
              ))}
            </div>
          </div>
        </section>

    );
}
